/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BrokerGroupsResponseDto } from './BrokerGroupsResponseDto';
import {
    BrokerGroupsResponseDtoFromJSON,
    BrokerGroupsResponseDtoFromJSONTyped,
    BrokerGroupsResponseDtoToJSON,
    BrokerGroupsResponseDtoToJSONTyped,
} from './BrokerGroupsResponseDto';
import type { UploadedFileResponseDto } from './UploadedFileResponseDto';
import {
    UploadedFileResponseDtoFromJSON,
    UploadedFileResponseDtoFromJSONTyped,
    UploadedFileResponseDtoToJSON,
    UploadedFileResponseDtoToJSONTyped,
} from './UploadedFileResponseDto';

/**
 * 
 * @export
 * @interface BrokerResponseDto
 */
export interface BrokerResponseDto {
    /**
     * 
     * @type {Date}
     * @memberof BrokerResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof BrokerResponseDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof BrokerResponseDto
     */
    brokerId: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerResponseDto
     */
    status: BrokerResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BrokerResponseDto
     */
    type: BrokerResponseDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BrokerResponseDto
     */
    group: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerResponseDto
     */
    brokerEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerResponseDto
     */
    legalEntityName: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerResponseDto
     */
    claimsEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerResponseDto
     */
    financeEmail: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerResponseDto
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerResponseDto
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerResponseDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerResponseDto
     */
    postcode: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerResponseDto
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerResponseDto
     */
    website: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrokerResponseDto
     */
    hasToba: boolean;
    /**
     * 
     * @type {Date}
     * @memberof BrokerResponseDto
     */
    tobaCompletionDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof BrokerResponseDto
     */
    hasKyc: boolean;
    /**
     * 
     * @type {Date}
     * @memberof BrokerResponseDto
     */
    kycCompletionDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof BrokerResponseDto
     */
    state?: string;
    /**
     * 
     * @type {Array<UploadedFileResponseDto>}
     * @memberof BrokerResponseDto
     */
    files?: Array<UploadedFileResponseDto>;
    /**
     * 
     * @type {BrokerGroupsResponseDto}
     * @memberof BrokerResponseDto
     */
    brokerGroup?: BrokerGroupsResponseDto;
}


/**
 * @export
 */
export const BrokerResponseDtoStatusEnum = {
    Active: 'Active',
    Inactive: 'Inactive'
} as const;
export type BrokerResponseDtoStatusEnum = typeof BrokerResponseDtoStatusEnum[keyof typeof BrokerResponseDtoStatusEnum];

/**
 * @export
 */
export const BrokerResponseDtoTypeEnum = {
    Wholesale: 'Wholesale',
    Retail: 'Retail'
} as const;
export type BrokerResponseDtoTypeEnum = typeof BrokerResponseDtoTypeEnum[keyof typeof BrokerResponseDtoTypeEnum];


/**
 * Check if a given object implements the BrokerResponseDto interface.
 */
export function instanceOfBrokerResponseDto(value: object): value is BrokerResponseDto {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('brokerId' in value) || value['brokerId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('group' in value) || value['group'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('legalEntityName' in value) || value['legalEntityName'] === undefined) return false;
    if (!('financeEmail' in value) || value['financeEmail'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('postcode' in value) || value['postcode'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('website' in value) || value['website'] === undefined) return false;
    if (!('hasToba' in value) || value['hasToba'] === undefined) return false;
    if (!('hasKyc' in value) || value['hasKyc'] === undefined) return false;
    return true;
}

export function BrokerResponseDtoFromJSON(json: any): BrokerResponseDto {
    return BrokerResponseDtoFromJSONTyped(json, false);
}

export function BrokerResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrokerResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'brokerId': json['brokerId'],
        'status': json['status'],
        'type': json['type'],
        'group': json['group'],
        'name': json['name'],
        'brokerEmail': json['brokerEmail'] == null ? undefined : json['brokerEmail'],
        'legalEntityName': json['legalEntityName'],
        'claimsEmail': json['claimsEmail'] == null ? undefined : json['claimsEmail'],
        'financeEmail': json['financeEmail'],
        'phoneNumber': json['phoneNumber'],
        'address': json['address'],
        'city': json['city'],
        'postcode': json['postcode'],
        'country': json['country'],
        'website': json['website'],
        'hasToba': json['hasToba'],
        'tobaCompletionDate': json['tobaCompletionDate'] == null ? undefined : (new Date(json['tobaCompletionDate'])),
        'hasKyc': json['hasKyc'],
        'kycCompletionDate': json['kycCompletionDate'] == null ? undefined : (new Date(json['kycCompletionDate'])),
        'state': json['state'] == null ? undefined : json['state'],
        'files': json['files'] == null ? undefined : ((json['files'] as Array<any>).map(UploadedFileResponseDtoFromJSON)),
        'brokerGroup': json['brokerGroup'] == null ? undefined : BrokerGroupsResponseDtoFromJSON(json['brokerGroup']),
    };
}

export function BrokerResponseDtoToJSON(json: any): BrokerResponseDto {
    return BrokerResponseDtoToJSONTyped(json, false);
}

export function BrokerResponseDtoToJSONTyped(value?: BrokerResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'brokerId': value['brokerId'],
        'status': value['status'],
        'type': value['type'],
        'group': value['group'],
        'name': value['name'],
        'brokerEmail': value['brokerEmail'],
        'legalEntityName': value['legalEntityName'],
        'claimsEmail': value['claimsEmail'],
        'financeEmail': value['financeEmail'],
        'phoneNumber': value['phoneNumber'],
        'address': value['address'],
        'city': value['city'],
        'postcode': value['postcode'],
        'country': value['country'],
        'website': value['website'],
        'hasToba': value['hasToba'],
        'tobaCompletionDate': value['tobaCompletionDate'] == null ? undefined : ((value['tobaCompletionDate']).toISOString()),
        'hasKyc': value['hasKyc'],
        'kycCompletionDate': value['kycCompletionDate'] == null ? undefined : ((value['kycCompletionDate']).toISOString()),
        'state': value['state'],
        'files': value['files'] == null ? undefined : ((value['files'] as Array<any>).map(UploadedFileResponseDtoToJSON)),
        'brokerGroup': BrokerGroupsResponseDtoToJSON(value['brokerGroup']),
    };
}

